import team from './team';
import { positions } from './career';
import services from './services';
import blogs from './blogs';
import products from './products';
import projects from './projects';



const navbar = [
    {
        id: 1,
        mainLink : {link: '/', title: 'Home'},
        subLink: [],
    },
    {
        id: 2,
        mainLink : {link: '#', title: 'about'},
        subLink: [
            {id: 1, link: '/About-us', title: 'About Us'},
            {id: 2, link: '/Team', title: 'Team'},
            {id: 3, link: '/Team/TeamSingle', title: 'Team Single', state: team[0]},
            {id: 4, link: '/Testimonials', title: 'testimonials'},
            {id: 5, link: '/Faqs', title: 'faqs'},
        ],
    },
    {
        id: 3,
        mainLink: { title: "Pages", link: "#" },
        subLink: [
            { id: 1, link: "/Pricing", title: "Pricing" },
            { id: 2, link: "/Process", title: "Work Process" },
            {
                id: 3,
                title: "Career",
                children: [
                    { id: 1, link: "/Careers", title: "Careers" },
                    { id: 2, link: "/Careers/Position-Single", title: "Career Single",  state: positions[0] },
                    { id: 3, link: "/Career-Form", title: "Career Form" },
                ],
            },
            { id: 4, link: "/Get-Quote", title: "Get Quote" },
            { id: 5, link: "/Cost-Calculator", title: "Cost Calculator" },
            { id: 6, link: "/Partners", title: "Partners" },
        ],
    },
    {
        id: 4,
        mainLink : {link: '#', title: 'Service'},
        subLink: [
            { id: 1, link: "/Services", title: "Services" },
            { id: 2, link: "/Services/Service-Single", title: "Service Single",  state: services[0] },
        ],
    },
        {
        id: 5,
        mainLink : {link: '#', title: 'Project'},
        subLink: [
            { id: 1, link: "/Projects", title: "Projects" },
            { id: 2, link: "/Projects/Project-Single", title: "Project Single",  state: projects[0] },
        ],
    },
    {
        id: 6,
        mainLink : {link: '#', title: 'blog'},
        subLink: [
            {id: 1, link: '/Blog-grid', title: 'blog grid'},
            {id: 2, link: '/Blog-list', title: 'blog list'},
            {id: 3, link: '/Blogs/Blog-Single', title: 'blog single', state: blogs[0]},
        ],
    },
    {
        id: 7,
        mainLink : {link: '#', title: 'shop'},
        subLink: [
            {id: 1, link: '/Shop-grid', title: 'shop grid'},
            {id: 2, link: '/Shop-list', title: 'shop list'},
            {id: 3, link: '/Shop/Product-Single', title: 'product single', state: products[0]},
            {id: 4, link: '/Wishlist', title: 'wishlist'},
            {id: 5, link: '/Cart', title: 'cart'},
            {id: 6, link: '/Checkout', title: 'checkout'},
            {id: 7, link: '/OrderConfirmation', title: 'Order Confirmation'},
            {id: 8, link: '/Login', title: 'login'},
            {id: 9, link: '/Register', title: 'register'},
            {id: 10, link: '/Forgot-pwd', title: 'forgot Password'},
        ],
    },
    {
        id: 8,
        mainLink : {link: '/Contact-us', title: 'contact'},
        subLink: [],
    },
];

export default navbar;